import api from './api'
import { ConsultaCnpj } from '@/types/cnpj'
import { normalizarCnpj } from '@/utils/cnpj'

const BASE_URL = '/api/v1/clientes/cnpj'

/**
 * Consulta cadastral por CNPJ (Etapa 1 da Nova oportunidade — Onda 3).
 *
 * O backend nunca devolve 5xx para provedor fora do ar: vem 200 com
 * `disponivel=false` e a tela cai no preenchimento manual. O único erro esperado é
 * 400 CNPJ_INVALIDO (dígito verificador não fecha; CNPJ pode ser alfanumérico) — que a máscara + `cnpjValido`
 * daqui já evitam antes de chamar.
 */
export const cnpjService = {
  consultar: async (cnpj: string): Promise<ConsultaCnpj> => {
    const normalizado = normalizarCnpj(cnpj)
    const response = await api.get<ConsultaCnpj>(`${BASE_URL}/${normalizado}/consulta`)
    return response as unknown as ConsultaCnpj
  },
}

// Validação e máscara moram em `@/utils/cnpj` (numérico e alfanumérico); reexportadas
// aqui porque as telas da Nova oportunidade já as importam deste módulo.
export { cnpjValido, mascararCnpj } from '@/utils/cnpj'
